<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col cols="12">
            Míváte migrény?
          </v-col>
          <v-col cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.migraine.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.migraine.status == '1' ? 'required' : ''"
              v-model="form.migraine.value.frequency"
              label="Jak často?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.migraine.status != '1'" />
            <VRadioWithValidation
              :disabled="form.migraine.status !== '1'"
              :rules="form.migraine.status == '1' ? 'required' : ''"
              v-model="form.migraine.value.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="S aurou"
                       value="yes" />
              <v-radio color="blue lighten-1"
                       label="Bez aury"
                       value="no" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Trpíte poruchou sluchu?
          </v-col>
          <v-col cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.hearingImpairment.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.hearingImpairment.status == '1' ? 'required' : ''"
              v-model="form.hearingImpairment.value"
              label="Jakou?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.hearingImpairment.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Trpíte poruchou zraku?
          </v-col>
          <v-col cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.visualImpairment.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.visualImpairment.status == '1' ? 'required' : ''"
              v-model="form.visualImpairment.value"
              label="Jakou?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.visualImpairment.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Pozorujete zhoršení paměti (vštípivost, výbavnost), v posledních dvou letech?
          </v-col>
          <v-col cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.impairedMemory.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheNeurodegenerative',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        migraine: {
          status: 0,
          value: {
            frequency: '',
            status: 0
          }
        },
        hearingImpairment: {
          status: 0,
          value: ''
        },
        visualImpairment: {
          status: 0,
          value: ''
        },
        impairedMemory: {
          status: 0,
          value: 'string'
        }
      },
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        migraine: {
          status: Number(this.form.migraine.status),
          value: JSON.stringify({
            frequency: this.form.migraine.value.frequency,
            status: this.form.migraine.value.status
          })
        },
        hearingImpairment: {
          status: Number(this.form.hearingImpairment.status),
          value: this.form.hearingImpairment.value
        },
        visualImpairment: {
          status: Number(this.form.visualImpairment.status),
          value: this.form.visualImpairment.value
        },
        impairedMemory: {
          status: Number(this.form.impairedMemory.status),
          value: this.form.impairedMemory.value
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/neurodegenerativemental', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/neurodegenerativemental', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        migraine: {
          status: String(data.migraine.status),
          value: JSON.parse(data.migraine.value)
        },
        hearingImpairment: {
          status: String(data.hearingImpairment.status),
          value: data.hearingImpairment.value
        },
        visualImpairment: {
          status: String(data.visualImpairment.status),
          value: data.visualImpairment.value
        },
        impairedMemory: {
          status: String(data.impairedMemory.status),
          value: 'string'
        }
      };
    });
  }
};
</script>
